// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottomAd_box":"bottomAd_box-3r6BuWcY","bottomAd":"bottomAd-1iwYksmO"};